'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getAfterStyle = exports.getAfterStyle = function getAfterStyle() {
  return {
    display: 'table',
    clear: 'both'
  };
};

var getAfterContentStyle = exports.getAfterContentStyle = function getAfterContentStyle() {
  return {
    display: 'none'
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/react-grid-system/build/utilities/ClearFix/style.js
// module id = 2782
// module chunks = 0